import "./App.css";
import "./css/base/buttons/buttons.css";
import "./css/base/Popup/Popup.css";
import Deline from "./components/Deline";
import Transaction from "./components/Wallet/Transaction";
import Settings from "./components/Settings";
import Signin from "./components/Signin/Signin";
import PasswordRecovery from "./components/Signin/passwordRecovery/passwordRecovery.js";
import PasswordRecoveryStep2 from "./components/Signin/passwordRecovery/PasswordRecoveryStep2.js";
import Signup from "./components/Signin/Signup.js";
import Signin_verify from "./components/Signin/Signin_verify";
import Languages from "./components/Settings/Languages";
import Rules from "./components/Rules/Rules.js";

import { useState, useEffect } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";

import "./i18n.js";
import { useTranslation } from "react-i18next";
import Sessions from "./components/Settings/Sessions.js";
import Notifications from "./components/Notifications/Notifications.js";

import Menu from "./components/Menu/Menu.js";
import Footer from "./components/Footer/Footer.js";
import SessionChecker from "./components/SessionChecker/SessionChecker.js";
import Swap from "./components/Swap/Swap.js";
import WalletProvider from "./components/Wallet/WalletProvider.js";
import Token from "./components/Wallet/Token/Token.js";
import Wallet from "./components/Wallet/Wallet.js";
import Authentication from "./components/Authentication/Authentication.js";
import EditProfile from "./components/Profile/EditProfile.js";

import PasswordRecoveryStep3 from "./components/Signin/passwordRecovery/PasswordRecoveryStep3.js";
import AddProduct from "./components/Products/AddProduct/AddProduct.js";

import Home from "./components/Home/Home.js";
import Profile from "./components/Profile/Profile.js";
import Licenses from "./components/Licenses/Licenses.js";
import Search from "./components/Search/Search.js";
import Product from "./components/Products/Product/Product.js";
import ShoppingCart from "./components/ShoppingCart/ShoppingCart.js";

import "./css/Components/Components.css";
import History from "./components/Wallet/History/History.js";
import PurchasesHistory from "./components/Wallet/History/PurchasesHistory/PurchasesHistory.js";
import SalesHistory from "./components/Wallet/History/SalesHistory/SalesHistory.js";
import DepositsHistory from "./components/Wallet/History/DepositsHistory/DepositsHistory.js";
import WithdrawalsHistory from "./components/Wallet/History/WithdrawalsHistory/WithdrawalsHistory.js";
import SharedWallet from "./components/Wallet/SharedWallet/SharedWallet.js";
import BankAccounts from "./components/Wallet/SharedWallet/BankAccounts/BankAccounts.js";
import Receipts from "./components/Wallet/SharedWallet/Receipts/Receipts.js";
import UnconfirmedReceipts from "./components/Wallet/SharedWallet/Receipts/UnconfirmedReceipts.js";

function LayoutWithMenu({ theme }) {
  return (
    <div className="mainDiv">
      <Menu theme={theme}></Menu>
      <Outlet className="outLet" />
    </div>
  );
}

function LayoutWithFooter({ theme }) {
  return (
    <div className="mainDivWithFooter">
      <Outlet />
      <Footer theme={theme}></Footer>
    </div>
  );
}

export function getCookie(name) {
  const cookies = document.cookie.split("; ");

  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");

    if (key === name) {
      return decodeURIComponent(value);
    }
  }

  return null;
}

function App() {
  const [theme, setTheme] = useState(() => {
    const cookies = document.cookie.split(";");

    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key.trim() === "theme") {
        return value.trim();
      }
    }
    return "light";
  });

  const { t, i18n } = useTranslation();
  const cookies = document.cookie.split(";");

  // language
  useEffect(() => {
    document.body.className = theme;
    document.cookie = `theme=${theme}; max-age=32000000; path=/`;

    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key.trim() === "language") {
        i18n.changeLanguage(value.trim());
        document.documentElement.dir = value.trim() === "fa" ? "rtl" : "ltr";
      }
    }
  }, [theme, i18n]);

  return (
    <SessionChecker theme={theme}>
      <Router>
        <Routes>
          <Route
            path="/signin"
            element={<Signin theme={theme} setTheme={setTheme} />}
          />
          <Route
            path="/password_recovery"
            element={<PasswordRecovery theme={theme} setTheme={setTheme} />}
          />
          <Route
            path="/password_recovery_step2"
            element={
              <PasswordRecoveryStep2 theme={theme} setTheme={setTheme} />
            }
          />
          <Route
            path="/password_recovery_step3"
            element={
              <PasswordRecoveryStep3 theme={theme} setTheme={setTheme} />
            }
          />
          <Route
            path="/signup"
            element={<Signup theme={theme} setTheme={setTheme} />}
          />

          <Route element={<LayoutWithMenu theme={theme} />}>
            <Route element={<LayoutWithFooter theme={theme} />}>
              <Route
                path="/signin_verify"
                element={<Signin_verify theme={theme} />}
              />
              <Route path="/rules" element={<Rules theme={theme} />}></Route>

              <Route path="/" element={<Home theme={theme} />} />

              <Route
                path="/interal_accounting"
                element={
                  <WalletProvider>
                    <Wallet theme={theme} />
                  </WalletProvider>
                }
              />

              <Route
                path="/shared_wallet"
                element={<SharedWallet theme={theme}></SharedWallet>}
              >
                <Route
                  index
                  element={
                    <Navigate to={"/shared_wallet/receipts"} replace />
                  }
                ></Route>

                <Route
                  path="receipts"
                  element={<Receipts theme={theme}></Receipts>}
                ></Route>

                <Route
                  path="unconfirmed_receipts"
                  element={<UnconfirmedReceipts theme={theme}></UnconfirmedReceipts>}
                ></Route>

                <Route
                  path="bank_accounts"
                  element={<BankAccounts theme={theme}></BankAccounts>}
                ></Route>

              </Route>

              <Route
                path="token/:token"
                element={
                  <WalletProvider>
                    <Token theme={theme} />{" "}
                  </WalletProvider>
                }
              ></Route>

              <Route path="/home" element={<Home theme={theme} />}></Route>
              <Route path="/search" element={<Search theme={theme} />}></Route>

              <Route path="/history" element={<History theme={theme} />}>
                <Route
                  index
                  element={<Navigate to={"/history/deposits"} replace />}
                />

                <Route
                  path="deposits"
                  element={<DepositsHistory theme={theme} />}
                />

                <Route
                  path="withdrawals"
                  element={<WithdrawalsHistory theme={theme} />}
                />

                <Route
                  path="purchases"
                  element={<PurchasesHistory theme={theme} />}
                />

                <Route path="sales" element={<SalesHistory theme={theme} />} />
              </Route>

              <Route path="/swap" element={<Swap theme={theme} />} />
              <Route
                path="/transaction/:link"
                element={<Transaction theme={theme} />}
              />
              <Route path="/deline" element={<Deline />} />
              <Route
                path="/settings"
                element={<Settings theme={theme} setTheme={setTheme} />}
              />
              <Route
                path="/:username"
                element={<Profile theme={theme} setTheme={setTheme} />}
              />

              <Route
                path="/p/:product_link"
                element={<Product theme={theme}></Product>}
              ></Route>

              <Route
                path="/languages"
                element={<Languages theme={theme} />}
              ></Route>
              <Route
                path="/sessions"
                element={<Sessions theme={theme} />}
              ></Route>

              <Route
                path="/licenses"
                element={<Licenses theme={theme} />}
              ></Route>

              <Route
                path="/authentication"
                element={<Authentication theme={theme} />}
              ></Route>

              <Route
                path="/edit_profile"
                element={<EditProfile theme={theme} />}
              ></Route>

              <Route
                path="/add_product"
                element={<AddProduct theme={theme} />}
              ></Route>

              <Route
                path="/shopping_cart"
                element={<ShoppingCart theme={theme} />}
              ></Route>

              <Route
                path="/notifs"
                element={<Notifications theme={theme} />}
              ></Route>
            </Route>
          </Route>
        </Routes>
      </Router>
    </SessionChecker>
  );
}

export default App;
